import React from 'react';

export default function MikhalAvatar({ size = 80, className = '', animated = false }) {
  return (
    <svg width={size} height={size} viewBox="0 0 200 200" fill="none"
      xmlns="http://www.w3.org/2000/svg" className={className}>
      <defs>
        <radialGradient id="bgG" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#1a3820"/>
          <stop offset="100%" stopColor="#0a1f12"/>
        </radialGradient>
        <radialGradient id="faceG" cx="50%" cy="40%" r="60%">
          <stop offset="0%" stopColor="#d2eee4"/>
          <stop offset="100%" stopColor="#a8d4c2"/>
        </radialGradient>
        <radialGradient id="eyeG" cx="40%" cy="35%" r="60%">
          <stop offset="0%" stopColor="#00d4aa"/>
          <stop offset="100%" stopColor="#1a6b45"/>
        </radialGradient>
        {animated && (
          <style>{`
            .ms{animation:scan 2s ease-in-out infinite;}
            .mp{animation:pulse 3s ease-in-out infinite;}
            @keyframes scan{0%,100%{opacity:.3}50%{opacity:1}}
            @keyframes pulse{0%,100%{opacity:.4}50%{opacity:1}}
          `}</style>
        )}
      </defs>
      <circle cx="100" cy="100" r="98" fill="url(#bgG)"/>
      <circle cx="100" cy="100" r="96" stroke="#1a6b45" strokeWidth="1.5" strokeOpacity=".6" fill="none"/>
      <circle cx="100" cy="100" r="88" stroke="#c8a035" strokeWidth=".8" strokeOpacity=".3" fill="none"/>
      {[0,45,90,135,180,225,270,315].map((ang,i)=>{
        const r=90,rad=(ang*Math.PI)/180,x=100+r*Math.cos(rad),y=100+r*Math.sin(rad),m=ang%90===0;
        return <circle key={i} cx={x} cy={y} r={m?3.5:2} fill={m?'#c8a035':'#1d9e75'} opacity={m?.9:.6} className={animated?'mp':''}/>;
      })}
      <ellipse cx="100" cy="82" rx="42" ry="44" fill="url(#faceG)"/>
      <ellipse cx="100" cy="82" rx="42" ry="44" stroke="#1d9e75" strokeWidth="1" strokeOpacity=".5" fill="none"/>
      <path d="M58 70 Q60 36 100 33 Q140 36 142 70 L145 75 Q130 50 100 48 Q70 50 55 75 Z" fill="#0f2318"/>
      <path d="M72 50 Q100 44 128 50" stroke="#1a6b45" strokeWidth="2" fill="none" strokeOpacity=".8"/>
      {[-16,0,16].map((dx,i)=>(
        <g key={i}>
          <ellipse cx={100+dx} cy="40" rx="5" ry="4" fill="#c8a035" opacity=".9"/>
          <ellipse cx={100+dx} cy="40" rx="2.5" ry="2" fill="#fcd34d"/>
        </g>
      ))}
      <rect x="53" y="71" width="5" height="18" rx="2" fill="#0a1f12" opacity=".9"/>
      <circle cx="53" cy="80" r="9" fill="#0a1f12" stroke="#1d9e75" strokeWidth="1.5" opacity=".9"/>
      <circle cx="53" cy="80" r="4" fill="#c8a035"/>
      <rect x="142" y="71" width="5" height="18" rx="2" fill="#0a1f12" opacity=".9"/>
      <circle cx="147" cy="80" r="9" fill="#0a1f12" stroke="#1d9e75" strokeWidth="1.5" opacity=".9"/>
      <circle cx="147" cy="80" r="4" fill="#c8a035"/>
      {[83,117].map(ex=>(
        <g key={ex}>
          <ellipse cx={ex} cy="80" rx="13" ry="10" fill="white"/>
          <ellipse cx={ex} cy="80" rx="9" ry="7.5" fill="url(#eyeG)"/>
          <ellipse cx={ex} cy="80" rx="5" ry="4.5" fill="#0a1f12"/>
          <line x1={ex-11} y1="80" x2={ex+11} y2="80" stroke="#00d4aa" strokeWidth=".8" opacity=".7" className={animated?'ms':''}/>
          <circle cx={ex-4} cy="77" r="2.5" fill="white" opacity=".8"/>
        </g>
      ))}
      <path d="M72 67 Q83 63 94 67" stroke="#0f2318" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
      <path d="M106 67 Q117 63 128 67" stroke="#0f2318" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
      <path d="M97 92 Q100 96 103 92" stroke="#8bbdae" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
      <path d="M86 102 Q100 112 114 102" stroke="#3d8870" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
      <path d="M89 103 Q100 110 111 103" stroke="white" strokeWidth="1.2" fill="none" strokeLinecap="round" opacity=".6"/>
      <ellipse cx="76" cy="96" rx="8" ry="5" fill="#e87070" opacity=".18"/>
      <ellipse cx="124" cy="96" rx="8" ry="5" fill="#e87070" opacity=".18"/>
      <rect x="88" y="124" width="24" height="12" rx="4" fill="#b8ddd0"/>
      <polygon points="100,136 130,148 130,168 100,180 70,168 70,148" fill="#1a6b45" stroke="#1d9e75" strokeWidth="1.5" opacity=".95"/>
      <polygon points="100,140 126,151 126,165 100,176 74,165 74,151" fill="#0f2318" opacity=".7"/>
      <circle cx="100" cy="158" r="11" fill="#0a1f12" stroke="#c8a035" strokeWidth="1.5"/>
      <text x="100" y="163" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#fcd34d" fontFamily="Arial">M</text>
      {[[60,-1],[140,1]].map(([bx,d],i)=>{
        const by=74;
        return (
          <g key={i} opacity=".7">
            <line x1={bx} y1={by} x2={bx+d*10} y2={by} stroke="#1d9e75" strokeWidth="1"/>
            <line x1={bx+d*10} y1={by} x2={bx+d*10} y2={by+8} stroke="#1d9e75" strokeWidth="1"/>
            <circle cx={bx+d*10} cy={by+8} r="1.5" fill="#c8a035"/>
            <line x1={bx+d*10} y1={by+8} x2={bx+d*18} y2={by+8} stroke="#1d9e75" strokeWidth="1"/>
            <circle cx={bx+d*18} cy={by+8} r="1.5" fill="#1d9e75"/>
          </g>
        );
      })}
    </svg>
  );
}
